<template>
  <div id="loading">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
            <span>
              <font-awesome-icon class="fa-spin" :icon="['fas', 'spinner']"/><br>{{(message) ? message : 'Aguarde, carregando...'}}
            </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {fasSpinner} from '@fortawesome/fontawesome-free-solid'

export default {
  props: ['message'],
  name: 'Loading',
  components: {
    FontAwesomeIcon
  }
}

</script>

<style lang="scss">
  #loading{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    width: 100%;
    min-height: 100vh;
    opacity: 0.7;
    z-index: 9999;

    span{
      display: block;
      font-size: 34px;
      color: #000;
      width: 100%;
      margin-top: 300px;
      text-align: center;
      font-weight: bold;
      font-family: RalewayRegular;

      @media screen and (max-width: 767px ){
        font-size: 24px;
      }
    }
    .fa-spin{
      color: #000;
      font-size: 50px;
      margin: 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/includes/Loading.vue